import { IconArrowDown, IconArrowUp, IconSort } from '@hulu-react-style-components/icons';
import styled from 'styled-components';

export const StyledSortArrow = styled(IconSort)`
  width: 14px;
  height: 14px;
  margin: 0 0 0 6px;

  path {
    fill: ${({ theme }): string => theme.admanColors!.gray.light.fg[4]};
  }
`;

export const StyledArrowUp = styled(IconArrowUp)`
  width: 14px;
  height: 14px;
  margin: 0 0 0 6px;

  path {
    fill: ${({ theme }): string => theme.admanColors!.blue.dark.bg1[0]};
  }
`;

export const StyledArrowDown = styled(IconArrowDown)`
  width: 14px;
  height: 14px;
  margin: 0 0 0 6px;

  path {
    fill: ${({ theme }): string => theme.admanColors!.blue.dark.bg1[0]};
  }
`;
